import { StaticImageData } from 'next/image';

import qlab1Icon from '@/assets/icons/qlab-1-icon.png';
import qlab3Icon from '@/assets/icons/qlab-3-icon.png';
import qlab4Icon from '@/assets/icons/qlab-4-icon.png';
import qlab5Icon from '@/assets/icons/qlab-5-icon.png';

export const versionIcons: Record<string, StaticImageData> = {
  v1: qlab1Icon,
  v2: qlab1Icon,
  v3: qlab3Icon,
  v4: qlab4Icon,
  v5: qlab5Icon,
};

export const docsContainerClass = 'docs-container';

export const getDocsSlug = (slug?: string) => {
  if (!slug) {
    return '';
  }
  const [path, hash] = slug.split('#');
  return hash ? `/docs${path}#${hash}` : `/docs${slug}/`;
};

// Matches an RFC 3986 scheme followed by ':' (https:, mailto:, tel:, etc.).
// Used to short-circuit computeRelativePath for fully-qualified URLs so we
// don't accidentally prefix the current pathname onto something like
// https://downloads.qlab.app/....
const ABSOLUTE_URL_RE = /^[a-z][a-z0-9+.-]*:/i;

// FUTURE: this util only exists because react-markdown.tsx overrides <a>
// with <RelativeLink> (Next.js <Link>), and <Link> does not do RFC 3986
// resolution against the current pathname. figure53/'s react-markdown has
// no `a:` override and no bug -- the browser handles resolution natively.
// Two ways to delete computeRelativePath + RelativeLink entirely:
//   (A) Drop the `a:` override in react-markdown.tsx; emit a plain <a>.
//       Loses Next.js client-side nav for in-doc links, gains correctness
//       including protocol-relative `//host` URLs and `..`-past-root (both
//       still wrong here). Smallest diff. Matches figure53/.
//   (B) Resolve relative links at build time via a remark/rehype plugin
//       so the href is already absolute when react-markdown sees it. Keeps
//       <Link> if client-side nav matters. Bigger lift.
// Either approach also drops the javascript:/data: pass-through that the
// scheme check below now permits. gobutton/ has a duplicate of this util
// with the same caveats.
export const computeRelativePath = (basePath: string, relativePathProp: string) => {
  // Pass through fully-qualified URLs (https://..., mailto:..., tel:...).
  // These don't start with '/', './', or '../', and the relative-path logic
  // below would otherwise prepend './' and concatenate with basePath.
  if (ABSOLUTE_URL_RE.test(relativePathProp)) {
    return relativePathProp;
  }

  let relativePath = relativePathProp.replace(/\/$/, '');
  basePath = basePath.replace(/\/$/, '');
  if (
    // If it isn't absolute but also doesn't have any relative indicators, make it relative to the current directory
    !relativePath.startsWith('/') &&
    !relativePath.startsWith('./') &&
    !relativePath.startsWith('../')
  ) {
    relativePath = `./${relativePath}`;
  }

  const parts = relativePath.split('/');
  const baseParts = basePath.split('/');

  if (['.', '..'].includes(parts[0])) {
    parts.forEach((part) => {
      if (part === '.') {
        // Current directory, do nothing
      } else if (part === '..') {
        // Parent directory, remove last part of basePath
        baseParts.pop();
      }
    });
  } else {
    return relativePath; // Not a relative path, return as is
  }

  // Join the remaining baseParts with the parts to form the new path
  relativePath = baseParts.concat(parts.filter((p) => p !== '.' && p !== '..')).join('/');

  return relativePath;
};
